/**
 * Parses raw SSE text into structured events.
 * Handles buffering across chunk boundaries (incomplete lines).
 */
export interface SseEvent {
  type: string
  data: unknown
}

export class SseParser {
  private buffer = ""

  /**
   * Feed a chunk of raw SSE text. Returns any complete events found.
   */
  feed(chunk: string): SseEvent[] {
    this.buffer += chunk
    const events: SseEvent[] = []

    // Split by double newline (SSE event boundary)
    const parts = this.buffer.split("\n\n")

    // Last part may be incomplete — keep it in buffer
    this.buffer = parts.pop() || ""

    for (const part of parts) {
      const trimmed = part.trim()
      if (!trimmed) continue

      let eventType = "message"
      let dataLines: string[] = []

      for (const line of trimmed.split("\n")) {
        if (line.startsWith("event: ")) {
          eventType = line.slice(7).trim()
        } else if (line.startsWith("data: ")) {
          dataLines.push(line.slice(6))
        } else if (line.startsWith("data:")) {
          dataLines.push(line.slice(5))
        }
      }

      if (dataLines.length > 0) {
        const raw = dataLines.join("\n")
        try {
          events.push({ type: eventType, data: JSON.parse(raw) })
        } catch {
          // Non-JSON data — store as string
          events.push({ type: eventType, data: raw })
        }
      }
    }

    return events
  }

  reset() {
    this.buffer = ""
  }
}
